import 'firebase/database';
import 'firebase/auth';
import firebase from 'firebase/app';
import uuidv4 from 'uuid/v4';

// GET CONTRACTS
export const GET_STICKERS_PENDING = 'GET_STICKERS_PENDING';
export const GET_STICKERS_FULFULLED = 'GET_STICKERS_FULFULLED';
export const GET_STICKERS_REJECTED = 'GET_STICKERS_REJECTED';

export const GET_STICKER_PENDING = 'GET_STICKER_PENDING';
export const GET_STICKER_FULFULLED = 'GET_STICKER_FULFULLED';
export const GET_STICKER_REJECTED = 'GET_STICKER_REJECTED';

export const DELETE_STICKER_PENDING = 'DELETE_STICKER_PENDING';
export const DELETE_STICKER_FULFILLED = 'DELETE_STICKER_FULFILLED';
export const DELETE_STICKER_REJECTED = 'DELETE_STICKER_REJECTED';

export const CREATE_STICKER_PENDING = 'CREATE_STICKER_PENDING';
export const CREATE_STICKER_FULFILLED = 'CREATE_STICKER_FULFILLED';
export const CREATE_STICKER_REJECTED = 'CREATE_STICKER_REJECTED';

export const ADD_SEGMENT_TO_STICKER_PENDING = 'ADD_SEGMENT_TO_STICKER_PENDING';
export const ADD_SEGMENT_TO_STICKER_FULFILLED = 'ADD_SEGMENT_TO_STICKER_FULFILLED';
export const ADD_SEGMENT_TO_STICKERT_REJECTED = 'ADD_SEGMENT_TO_STICKERT_REJECTED';

export const ADD_EQUIPMENT_TYPES_TO_STICKER_PENDING = 'ADD_EQUIPMENT_TYPES_TO_STICKER_PENDING';
export const ADD_EQUIPMENT_TYPES_TO_STICKER_FULFILLED = 'ADD_EQUIPMENT_TYPES_TO_STICKER_FULFILLED';
export const ADD_EQUIPMENT_TYPES_TO_STICKER_REJECTED = 'ADD_EQUIPMENT_TYPES_TO_STICKER_REJECTED';

export const REMOVE_EQUIPMENT_TYPE_FROM_STICKER_PENDING = 'REMOVE_EQUIPMENT_TYPE_FROM_STICKER_PENDING';
export const REMOVE_EQUIPMENT_TYPE_FROM_STICKER_FULFILLED = 'REMOVE_EQUIPMENT_TYPE_FROM_STICKER_FULFILLED';
export const REMOVE_EQUIPMENT_TYPE_FROM_STICKER_REJECTED = 'REMOVE_EQUIPMENT_TYPE_FROM_STICKER_REJECTED';

export const REMOVE_SEGMENT_FROM_STICKER_PENDING = 'REMOVE_SEGMENT_FROM_STICKER_PENDING';
export const REMOVE_SEGMENT_FROM_STICKER_FULFILLED = 'REMOVE_SEGMENT_FROM_STICKER_FULFILLED';
export const REMOVE_SEGMENT_FROM_STICKER_REJECTED = 'REMOVE_SEGMENT_FROM_STICKER_REJECTED';

//RETRIEVAL
const getStickers = () => (dispatch) => {
    dispatch({
        type: GET_STICKERS_PENDING
    }); 
    firebase.database().ref('/planogramAccessories/').child(localStorage.getItem('companyID')).once('value').then(snapshot => {
        const stickers = snapshot.val();

        var foundStickers = [];
        if (stickers !== null) {

            let stickersWithIds = Object.keys(stickers).map((stickerID) => { 
                let sticker = stickers[stickerID];
                sticker['id'] = stickerID;
                return sticker;
            });

            foundStickers = Object.values(stickersWithIds);
        }

        dispatch({
            type: GET_STICKERS_FULFULLED,
            payload: foundStickers
        });
    });
};

const getSticker = (stickerID) => (dispatch) => {
    dispatch({
        type: GET_STICKER_PENDING
    }); 

    firebase.database().ref('/planogramAccessories/' + localStorage.getItem('companyID') + '/' + stickerID).once('value').then(snapshot => {
        let sticker = snapshot.val();
        if(sticker != undefined && sticker != null) {
            sticker.id = stickerID;
        }

        dispatch({
            type: GET_STICKER_FULFULLED,
            payload: sticker
        });
    });

};

//SEGMENTS
const removeSegmentFromSticker = (segmentId, stickerId) => (dispatch) => {

    dispatch({
        type: REMOVE_SEGMENT_FROM_STICKER_PENDING
    }); 
 
    firebase.database().ref('planogramAccessories').child(localStorage.getItem('companyID')).child(stickerId).child('segments').child(segmentId).set(null);

    dispatch({
        type: REMOVE_SEGMENT_FROM_STICKER_FULFILLED,
        payload: {
            equipmentId: stickerId,
            segmentId: segmentId
        }
    }); 
};

const addSegmentToSticker = (segmentIds, stickerIds) => dispatch => {
    dispatch({
        type: ADD_SEGMENT_TO_STICKER_PENDING
    }); 
    
    for(let segmentId of segmentIds){
        for(let itemID of stickerIds) {
            firebase.database().ref('planogramAccessories/' + localStorage.getItem('companyID') + '/' + itemID + '/segments/' + segmentId).set(true);
        }
    }

    dispatch({
        type: ADD_SEGMENT_TO_STICKER_FULFILLED,
        payload:  {stickerIds : stickerIds, segmentIds: segmentIds }
    }); 
};

//EQUIPMENT TYPES

const addEquipmentTypesToSticker = (equipmentTypes, stickerId) => dispatch => {
    dispatch({
        type: ADD_EQUIPMENT_TYPES_TO_STICKER_PENDING
    });

    firebase.database().ref('planogramAccessories/' + localStorage.getItem('companyID') + '/' + stickerId + '/equipmentTypes').set(equipmentTypes);

    dispatch({
        type: ADD_EQUIPMENT_TYPES_TO_STICKER_FULFILLED,
        payload: {
            equipmentTypes: equipmentTypes,
            stickerId: stickerId
        }
    });
};

const removeEquipmentTypeFromSticker = (updatedTypes, stickerId) => dispatch => {
    dispatch({
        type: REMOVE_EQUIPMENT_TYPE_FROM_STICKER_PENDING
    });

    firebase.database().ref('planogramAccessories/' + localStorage.getItem('companyID') + '/' + stickerId + '/equipmentTypes').set(updatedTypes);

    dispatch({
        type: REMOVE_EQUIPMENT_TYPE_FROM_STICKER_FULFILLED,
        payload: {
            equipmentTypes: updatedTypes,
            stickerId: stickerId
        }
    });
};

//DELETION
const deleteSticker = (sticker) =>  (dispatch) => {
    dispatch({
        type: DELETE_STICKER_PENDING
    });
    
    firebase.database().ref('planogramAccessories').child(localStorage.getItem('companyID')).child(sticker.id).set(null);

    deleteFiles(sticker).then(() => {
        dispatch({
            type: DELETE_STICKER_FULFILLED,
            payload: sticker.id
        });
    }).catch(() => {
        dispatch({
            type: DELETE_STICKER_REJECTED
        });
    });
};

const deleteFiles = (sticker) => {
    return new Promise((resolve, reject) => {
        let filesToDelete = [];

        filesToDelete.push({
            path: 'accessories',
            file: sticker.image
        });

        if (filesToDelete.length > 0) {
            let fileCount = 0;
    
            for (let file of filesToDelete) {

                deleteFile(file).then((successful) => {
                    if (successful) {
                        fileCount ++;
                        if (fileCount == filesToDelete.length) {
                            resolve();
                        }
                    } else {
                        reject();
                    }
                });
            }
        } else {
            resolve();
        }
    });
};

const deleteFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.file).delete().then(function() {
            resolve(true);
        }).catch(() => {
            reject(false);
        });
    });
};

//UPLOAD
const uploadSticker = (metadata, files) => (dispatch) => {
    dispatch({
        type: CREATE_STICKER_PENDING
    });
    
    uploadFiles(metadata, files).then(() => {
        var newPostKey = firebase.database().ref().child('planogramAccessories').child(localStorage.getItem('companyID')).push().key;
        var updates = {};
        updates['/planogramAccessories/' + localStorage.getItem('companyID') + '/' + newPostKey] = metadata;
        firebase.database().ref().update(updates);

        dispatch({
            type: CREATE_STICKER_FULFILLED
        });
    }).catch(() => {
        dispatch({
            type: CREATE_STICKER_REJECTED
        });
    });
};

const uploadFiles = (metadata, files) => {
    return new Promise((resolve, reject) => {
        let filesToUpload = [];

        let uniqueName = uuidv4() + metadata.image;
        filesToUpload.push({
            path: 'accessories',
            filename: uniqueName,
            file: getFileForFilename(metadata.image, files) 
        });

        let previewImageName =  uuidv4() + metadata['preview-image'];
        filesToUpload.push({
            path: 'preview-images',
            filename: previewImageName,
            file: getFileForFilename(metadata['preview-image'], files) 
        });

        metadata['preview-image'] = previewImageName;
        metadata.image = uniqueName;

        let fileCount = 0;
    
        for (let file of filesToUpload) {

            uploadFile(file).then((successful) => {
                if (successful) {
                    fileCount ++;
                    if (fileCount == filesToUpload.length) {
                        resolve();
                    }
                } else {
                    reject();
                }
            });

        }
    });
};

const getFileForFilename = (filename, files) => {
    return files.filter(file => file.name === filename)[0];
};

const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
        firebase.storage().ref().child('/' + file.path + '/' + file.filename).put(file.file).then(function() {
            resolve(true);
        }).catch(() => {
            reject(false);
        });
    });
};

export { getStickers, deleteSticker, uploadSticker, getSticker, removeSegmentFromSticker, addSegmentToSticker, addEquipmentTypesToSticker, removeEquipmentTypeFromSticker};


// WEBPACK FOOTER //
// ./src/components/state/actions/StickerActions.js